export default "__VITE_ASSET__BcnCKdua__"